import React from "react";
import { Route, Redirect } from "react-router-dom";


function PrivateRoute({ component: Component, isLoggedIn, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn 
        ? ( <Component className="private-route-component" {...props} /> ) 
        : ( <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          )
      }
    />
  );
}

export default PrivateRoute;
